import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { Typography, Button } from '@mic3/platform-ui';

import { createEvent } from 'app/utils/http/event';
import { get } from 'app/utils/lo/lo';
import Geocode from 'app/utils/maps/geocodeUtils';
import { bind } from 'app/utils/decorators/decoratorUtils';
import LocationMap from '../LocationMap/LocationMap';
import { isDefined } from 'app/utils/utils';


const myCurrentLocationError = () =>
    console.log({ severity: 'error', detail: 'Could not get your location, please allow location tracking in your browser' }); // eslint-disable-line no-console

class MyLocationMap extends PureComponent {
    static propTypes = {
        value: PropTypes.object,
        disabled: PropTypes.bool,
        name: PropTypes.string,
        onChange: PropTypes.func,
        showCoords: PropTypes.bool,
        readOnly: PropTypes.bool,
    };

    static defaultProps = {
        showCoords: false,
        readOnly: false,
    };

    mapRef = React.createRef();

    componentDidMount() {
        if (!this.props.value) {
            this.myLocation();
        }
    }

    @bind
    onChange(locationInfo) {
        if (this.props.onChange) {
            const name = this.props.name;
            const value = locationInfo;
            const event = createEvent('change', { name, value });
            this.props.onChange(event);
        }
    }

    @bind
    centerMap() {
        this.mapRef?.current?.centerMap();
    }

    @bind
    myLocation() {
        Geocode.getCurrentLocation(this.myCurrentLocation, myCurrentLocationError);
    }

    @bind
    myCurrentLocation(position) {
        this.onChange({ latitude: position.coords.latitude, longitude: position.coords.longitude });
    }

    @bind
    handleMarkerPostionChange({ lat, lng }) {
        this.myCurrentLocation({ coords: { latitude: lat, longitude: lng } });
    }

    render() {
        const { value, disabled, showCoords, allowPinDrag } = this.props;
        const latitude = get(value, 'latitude');
        const longitude = get(value, 'longitude');
        const markers = [{ lat: latitude, lng: longitude }];
        const isValueValid = isDefined(latitude) && isDefined(longitude);
        return (
            <Grid direction="column" container>
                {isValueValid && (
                    <LocationMap
                        ref={this.mapRef}
                        mapId="geo_tag_location_map"
                        markers={markers}
                        onChange={this.handleMarkerPostionChange}
                        allowPinDrag={!disabled && allowPinDrag}
                    />
                )}
                <Grid container justify="space-between">
                    {showCoords ? (
                        <Grid item>
                            {latitude && <Typography variant="button">Latitude: {latitude}</Typography>}
                            {longitude && <Typography variant="button">Longitude: {longitude}</Typography>}
                        </Grid>
                    ) : (
                        <Grid item />
                    )}
                    {!disabled && (
                        <Grid item>
                            <Button disabled={disabled || !isValueValid} onClick={this.centerMap} variant="text">
                                Center map
                            </Button>
                            <Button disabled={disabled} onClick={this.myLocation} variant="text">
                                My location
                            </Button>
                        </Grid>
                    )}
                </Grid>
            </Grid>
        );
    }
}

export default MyLocationMap;
